module.exports = __webpack_public_path__ + "img/image.0a0506cb.svg";